// HACK
// https://git.hubteam.com/HubSpot/Elsie/pull/162
// https://git.hubteam.com/HubSpot/reporting/issues/2577
export const CONTACT_SEARCH_AGGREGATION_MAX_SIZE = 1000;
export const CONTACT_SEARCH_AGGREGATION_MIN_SIZE = 500;
export const MAX_NUM_OF_METRICS = 20;